import React from "react";
import { ManagerProfileSection } from "../ManagerProfileSection";
import {
  ManagerProfileEditingSection,
  useManagerProfile,
} from "../ManagerProfileProvider";
import { Box } from "@chakra-ui/react";
import { ReadMore } from "../../common/ReadMore";
import { SocialLinks } from "../../common/SocialLinks";
import { htmlToText } from "../../../utils";

export const Overview: React.FC = () => {
  const { isEditing, manager, setEditingDrawer } = useManagerProfile();

  if (
    !isEditing &&
    !htmlToText(manager.descriptionHtml || "") &&
    !manager.socialMediaLinks?.length
  ) {
    return <></>;
  }

  return (
    <ManagerProfileSection
      w={"100%"}
      title={"Overview"}
      action={() => setEditingDrawer(ManagerProfileEditingSection.Overview)}
      mr={6}
    >
      {manager && (
        <Box textStyle={"bodyRegular"} color={"text.black"} mb={8} pr={4}>
          <ReadMore limit={0} text={manager.descriptionHtml || ""} />
        </Box>
      )}
      <SocialLinks links={manager.socialMediaLinks || []} />
    </ManagerProfileSection>
  );
};
